import ProfileProgressIndicatorContainer from './ProfileProgressIndicatorContainer';

export default ProfileProgressIndicatorContainer;
